import React from "react";
import { FaTruck, FaLock, FaLeaf, FaUserFriends } from "react-icons/fa";
import productImg from "../../assets/portfolio/model_bgc.webp";
import productImg2 from "../../assets/portfolio/model_pintoclock.webp";
import "./trustbuilder.css";

const trustPoints = [
  {
    icon: <FaTruck className="trust-icon" />,
    text: "Free Shipping",
    subtext: "On every UK order",
  },
  {
    icon: <FaLock className="trust-icon" />,
    text: "Secure Checkout",
    subtext: "Protected card payments",
  },
  {
    icon: <FaLeaf className="trust-icon" />,
    text: "Sustainable Materials",
    subtext: "Printed with less waste",
  },
  {
    icon: <FaUserFriends className="trust-icon" />,
    text: "Unisex Clothing",
    subtext: "Easy everyday fits",
  },
];

const TrustBuilder = () => {
  return (
    <section className="trust-section bg-color-footer color-subheading">
      <div className="content-padding">
        <div className="trust-layout">
          <div className="trust-images">
            <img
              src={productImg}
              className="trust-img"
              alt="Solo Pints graphic T-shirt flat lay"
            />
          </div>

          <div className="trust-copy">
            <p className="trust-eyebrow">Why shop Solo Pints?</p>
            <h2 className="trust-heading">
              Weekend-ready tees, printed with less waste.
            </h2>

            <ul className="trust-list">
              {trustPoints.map((point, idx) => (
                <li key={idx} className="trust-point">
                  {point.icon}

                  <span className="trust-text">
                    <strong>{point.text}</strong>
                    <small>{point.subtext}</small>
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBuilder;
